import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../../../../modules/src/lib/core/services/menu.service';
import { CreatePersonalClientFormFactory } from './create-personal-client-form.factory';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { CreatePersonalClientOptions } from '../../../../../../../../common/src/options/create-personal-client.options';
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';

@Component({
  selector: 'app-create-personal',
  templateUrl: './create-personal.component.html',
  styleUrls: ['./create-personal.component.scss'],
  standalone: false,
})
export class CreatePersonalComponent implements OnInit {

  public readonly form: AdvancedForm<CreatePersonalClientOptions> = this.personalClientFormFactory.create();

  constructor(public readonly personalClientFormFactory: CreatePersonalClientFormFactory, public menuService: MenuService) {
  }

  getFirstName(): AdvancedFormControl<string, string, string> {
    return this.form.get('firstName') as AdvancedFormControl<string, string, string>;
  }

  getLastName(): AdvancedFormControl<string, string, string> {
    return this.form.get('lastName') as AdvancedFormControl<string, string, string>;
  }

  ngOnInit(): void {
    this.form.buttonClick$.subscribe(() => {
      this.form.lifecycleStatus = FormLifecycleStatusEnum.Sending;

      setTimeout(() => {
        this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
      }, 800);
    });
  }

  getTitle() {
    const firstName = this.getFirstName().value;
    const lastName = this.getLastName().value;

    if (firstName == '' && lastName == '') {
      return 'Nouveau client particulier';
    }

    return firstName + ' ' + lastName;
  }
}
